"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertStringBooleanToBoolean = function (value) {
    if (!value)
        return false;
    return value + '' === 'true';
};
exports.stringToBoolean = function (string) {
    if (!string) {
        return false;
    }
    switch (string.toLowerCase().trim()) {
        case 'true':
        case 'yes':
        case '1':
            return true;
        case 'false':
        case 'no':
        case '0':
        case null:
            return false;
        default:
            return Boolean(string);
    }
};
//# sourceMappingURL=convert.js.map